import React from "react";

class Channel extends React.Component {
    constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
    };

    onClick = (event)=>{
        event.preventDefault() //阻止表单提交
        this.props.onClick(this.props.channelCode,this.props.channelName);
    }
    
    render() {
        let {channelName} = this.props;
        let {onClick} = this;
        return (
          <p> 
            <button type="button" className="btn btn-primary btn-lg btn-block"  onClick={onClick} >{channelName}</button>  
          </p>
        );
    }
  }
  
  export default Channel;